module.exports = __webpack_public_path__ + "img/xueyuan_tushi.9f5b39fb.png";